import { createContext, useContext } from 'react';
import type { FileRef, ResolvedContent } from '../content/types';

export interface ContentCtx {
  content: ResolvedContent;
  reportMissing: (key: string) => void;
}

export const ContentContext = createContext<ContentCtx | null>(null);

export function useContent(): ContentCtx {
  const c = useContext(ContentContext);
  if (!c) throw new Error('ContentContext sin proveedor');
  return c;
}

export function useSrc(): (f: FileRef | null | undefined) => string {
  return useContent().content.src;
}
